import { render, staticRenderFns } from "./BankFlow.vue?vue&type=template&id=0cab1934&"
import script from "./BankFlow.vue?vue&type=script&lang=js&"
export * from "./BankFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports